import type { ReactNode } from "react";

import type { TypographyProps } from "@braintrust/braintrust-ui-components";
import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { pluralize } from "@js/utils";

export type ResultsCountDataType = "TALENT" | "BIDS";

export const ResultsCount = ({
  dataType,
  count,
  total_count,
  wholeTextBold,
}: {
  dataType: ResultsCountDataType;
  count: number;
  total_count?: number;
  fontWeight?: TypographyProps["fontWeight"];
  wholeTextBold?: boolean;
}) => {
  const label = getLabelForResultsCount(dataType, count);
  if (total_count && total_count > 10000) {
    return (
      <ResultsCountContainer>
        <Typography
          fontWeight={500}
          component="span"
          sx={{ fontSize: "small" }}
        >
          {count.toLocaleString("en-US")}{" "}
        </Typography>
        results returned of{" "}
        <Typography
          fontWeight={500}
          component="span"
          sx={{ fontSize: "small" }}
        >
          {total_count.toLocaleString("en-US")}{" "}
        </Typography>
        {label}
      </ResultsCountContainer>
    );
  }

  return (
    <ResultsCountContainer>
      <Typography fontWeight={500} component="span" sx={{ fontSize: "small" }}>
        {count.toLocaleString("en-US")}{" "}
      </Typography>
      <Typography
        fontWeight={wholeTextBold ? 500 : 400}
        component="span"
        sx={{ fontSize: "small" }}
      >
        {label} found
      </Typography>
    </ResultsCountContainer>
  );
};

const ResultsCountContainer = ({ children }: { children: ReactNode }) => {
  return <Box sx={{ mr: 1 }}>{children}</Box>;
};

export const getLabelForResultsCount = (
  dataType: ResultsCountDataType,
  total: number,
) => {
  if (!dataType) {
    return "result" + pluralize(total, { zeroPlural: true });
  }

  const labelsByType = {
    TALENT: total === 1 ? "person" : "people",
    BIDS: "bid" + pluralize(total, { zeroPlural: true }),
  } satisfies Record<ResultsCountDataType, string>;

  return labelsByType[dataType];
};
